<template>
  <div>
    <h1 class="page-title mb-4">Routine: <span class="page-title-span">Create a new routine</span></h1>
    <ErrorDisplay/>
    <section class="widget routine-create">
      <b-row>
        <b-col sm="12 text-left" xl="6">
          <h3 class="fw-semi-bold">Enter a title for your Routine:</h3>
          <h5 class="example-font fw-normal mt-3 mb-4">Example: Closing Checklist, Frontdesk daily checklist</h5>
          <b-form class="routine-form">
              <b-form-group>
              <b-input-group>
                <b-input-group-text slot="prepend" class="bg-transparent">
                  <i class="fa fa-list-alt" />
                </b-input-group-text>
                <b-form-input v-model="routineName" type="text" size="lg" />
              </b-input-group>
            </b-form-group>
          </b-form>
          <h3 class="fw-semi-bold mt-5 mb-4">How often does this routine repeat?</h3>
         
          <b-form class="routine-form">
            <b-form-group>
              <multiselect v-model="repeats" :options="repeatOptions" :multiple="false"/>
            </b-form-group>
          </b-form>

      <!-- the below option will only be shown if the user selects 'WEEKLY' option -->
          <b-form class="routine-form routine-repeat-options" v-if="this.repeats === 'Weekly'">
            <span>Interval</span>
            <b-form-group>
              every
              <multiselect v-model="selectWeekInterval" :options="selectWeekIntervalOptions" :multiple="false"/>
              week on 
            </b-form-group>
            <b-form-group class="days-select">
              <b-form-group class="abc-checkbox">
                <b-form-checkbox v-model="whichDay" value="sunday">Sunday</b-form-checkbox>
              </b-form-group>

              <b-form-group class="abc-checkbox">
                <b-form-checkbox v-model="whichDay" value="monday">Monday</b-form-checkbox>
              </b-form-group>

              <b-form-group class="abc-checkbox">
                <b-form-checkbox v-model="whichDay" value="tuesday">Tuesday</b-form-checkbox>
              </b-form-group>

              <b-form-group class="abc-checkbox">
                <b-form-checkbox v-model="whichDay" value="wednesday">Wednesday</b-form-checkbox>
              </b-form-group>

              <b-form-group class="abc-checkbox">
                <b-form-checkbox v-model="whichDay" value="thursday">Thursday</b-form-checkbox>
              </b-form-group>

              <b-form-group class="abc-checkbox">
                <b-form-checkbox v-model="whichDay" value="friday">Friday</b-form-checkbox>
              </b-form-group>

              <b-form-group class="abc-checkbox">
                <b-form-checkbox v-model="whichDay" value="saturday">Saturday</b-form-checkbox>
              </b-form-group>
              
            </b-form-group>
          </b-form>

          <!-- the below option will only be shown if the user selects 'MONTHLY' option -->
          <b-form class="routine-form routine-repeat-options" v-if="repeats === 'Monthly'">
            <div>
              <span>Interval</span>
              <b-form-group>
                every
                <multiselect v-model="selectMonthInterval" :options="selectWeekIntervalOptions" :multiple="false"/>
                month(s)
              </b-form-group>
            </div>
            <div class="mt-3">
              <span style="margin-right: 48px;">On</span>
              <b-form-group>
                every
                <multiselect v-model="selectMonthDayInterval" :options="getMonthIntervalOptions" :multiple="false"/>
                day of the month
              </b-form-group>
            </div>
          </b-form>

          <div v-if="repeats === 'Yearly'" >On
            <DatePicker class="adjust-datepicker" lang="en" :placeholder="datepickerText" input-class="form-control" @change="selectDate">
             <i class="glyphicon glyphicon-th" slot="calendar-icon" />
            </DatePicker>
          </div>

        </b-col>

        <b-col sm="12 text-left" xl="6">
          <h3 class="fw-semi-bold mt-5 mt-xl-0 mb-4">Select team member(s) that should be assigned to this routine:</h3>
           <b-form class="routine-form">
            <multiselect
              v-if="this.employees"
              v-model="assignedToEmp"
              :options="this.employees"
              :multiple="false"
              :taggable="false"
              label="Name"
              track-by="Name" 
              aria-placeholder="Select a Team Member"
              >
                  <template slot="tag" slot-scope="props">
                  <span class="custom__tag">
                    <img class="option__image" src='../../assets/icons-user-40.png' alt="Team member image"/>
                    <span>{{ props.option.Name }}</span>
                    <i tabindex="1" class="multiselect__tag-icon" @click="removedMember(props.option)"></i>
                    <!-- <span class="custom__remove" @click="removedMember(props.option)">X</span> -->
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                <img class="option__image" src='../../assets/icons-user-40.png' alt="Team member image" />
                <div class="option__desc ">
                  <span class="option__title">{{ props.option.Name }}</span>
                </div>
              </template>
            </multiselect>
           </b-form>
        </b-col>

        <b-col sm="12 text-left">
          <h3 class="fw-semi-bold mt-5 mb-4">Content for your Routine:</h3>
          <b-form class="routine-form1">
               <CustomEditor :editorData="initData" :editorTools="editorTools" @save="save"></CustomEditor>
               <!--
               <div class="text-center">
                <button type="button" class="btn btn-success mr-xs mt-5 mb-4">Save Routine</button>
              </div>
              -->
           </b-form>
        </b-col>
      </b-row>
    </section>
    
  </div>
</template>

<script>
/* eslint-disable */

import Vue from 'vue';
// import vSelect from 'vue-select';
import Multiselect from "vue-multiselect";
import CustomEditor from "@/components/Editor/Editor.vue";
import ErrorDisplay from "@/components/ErrorDisplay/ErrorDisplay";
import { mapState, mapActions, mapMutations } from 'vuex';
import DatePicker from 'vue2-datepicker';
import _ from 'lodash';
import moment from 'moment-timezone';
import mixin from '../../mixin.js';

export default {
  
  name: 'CreateRoutine',
  
  components: {
    Multiselect, CustomEditor, DatePicker, ErrorDisplay
  },
  
  mixins: [mixin],
  
  data() {
    return {
      routineName: '',
      repeats: '',
      repeatOptions: ['Daily', 'Weekly', 'Monthly', 'Yearly'],
      selectWeekIntervalOptions: [1,2,3,4,5,6,7,8,9,10,11,12],
      simpleDropdownVariant: 'Select any option',
      selectWeekInterval: '1',
      selectMonthInterval: '1',
      selectMonthDayInterval: '1',
      whichDay: '',
      assignedToEmp: {},
      datepickerText: new Date().toLocaleDateString(),
      initData: {
        // time: 1554508385558,
        blocks: [
          {
            type: "header",
            data: { text: "Enter your page title...", level: 1 }
          }
        ]
        // version: "2.12.3"
      },
      editorTools: {
        header: {
          class: "Header",
          inlineToolbar: ["marker", "italic", "bold", "link"]
        },
        simpleImage: { class: "SimpleImage" },
        image: {
          class: "ImageTool",
          config: {
            uploader:{
            uploadByFile(file) {
              // your own uploading logic here
              // console.log(file);
              const formData = new FormData();
              formData.append("file", file);
              formData.append("upload_preset", 'idbhf8rq');
              return axios
                .post('https://api.cloudinary.com/v1_1/soumyanil/upload', formData)
                .then(res => {
                  // console.log("TCL: res", res);
                  return {
                    success: 1,
                    file:{
                      url: res.data.secure_url
                    }
                  } 
                })
                // .catch(err => {
                //   console.log("TCL: err", err);
                // });
              }
            }
          }
        },
        embed: {
          class: "Embed",
          inlineToolbar: true
        },
        list: {
          class: "List",
          inlineToolbar: true
        },
        delimiter: { class: "Delimiter" },
        table: {
          class: "Table",
          inlineToolbar: true
        },
        marker: {
          class: "Marker",
          shortcut: "CMD+SHIFT+M"
        },
        inlineCode: {
          class: "InlineCode",
          shortcut: "CMD+SHIFT+C"
        },
        paragraph: {
          class: "Paragraph",
          inlineToolbar: true
        }
      },
       existingLinks: [{
        name: 'Google',
        url: 'https://www.google.com',
      }, {
        name: 'Facebook',
        url: 'https://www.facebook.com',
      }, {
        name: 'Twitter',
        url: 'https://twitter.com',
      }, {
        name: 'Instagram',
        url: 'https://www.instagram.com/',
      }]
    };
  },
   methods: {

    ...mapActions('routines', ['createRoutine']),

    async save(e) {
      this.setErrored(false);

      if(this.routineName === '') {
        this.setErrored(true);
        this.setMessage(`Error while creating a routine: Please provide a routine name before saving.`);
        return;
      }

      if(_.isEmpty(this.assignedToEmp)) {
        this.setErrored(true);
        this.setMessage(`Error while creating a routine: Please select an employee to assign this routine to before saving.`);
        return;
      }

      if(this.repeats === '') {
        this.setErrored(true);
        this.setMessage(`Error while creating a routine: Please select how often this routine repeats before saving.`);
        return;
      }

      //console.log('saving routine:' + JSON.stringify(e));      
      const uploadedImages = _.filter(e.blocks, {"type": "image"}).map(function(object) {
        return _.get(object, 'data.file.url');
      });

      let payload = {
        SiteID: this.siteID,
        Name: this.routineName,
        Content: JSON.stringify(e),        
        CreatedByEmpID: this.userID,
        CreatedAt: moment().utc().format('YYYY-MM-DDTHH:mm:ss'),
        AssignedToEmpID: this.assignedToEmp.EmployeeID,
        Repeats: this.repeats,
        EveryHowMany: this.repeats === 'Daily'? null: this.interval,
        WhichDay: this.repeats === 'Weekly'? this.whichDay : null,
        DateOfMonth: this.repeats === 'Monthly'? this.selectMonthDayInterval : null,
        YearlyDate: this.repeats === 'Yearly' ? this.datepickerText : null,
      };
      //console.log('payload:' + JSON.stringify(payload));
      
      try {
        await this.createRoutine(payload);
        this.$router.push({name: 'Routine'});
      } catch(err){
        this.setErrored(true);
        this.setMessage(`Error while saving routine: ${err}`);
      }
    },

    changeSelectOption(field, value) {
      Vue.set(this, field, value);
    },
    
    removedMember(option){
      // console.log(option,this.$refs.multiTest);
      let removeIdx = this.value.findIndex((each)=>{ return each.name === option.name});
      this.value.splice(removeIdx, 1);
    },
    selectDate(val) {
      Vue.set(this, 'datepickerText', val.toLocaleDateString());
    },

  },

  computed: {
    getMonthIntervalOptions() {
      return [...Array(31+1).keys()].slice(1);
    },

    interval() {
      switch(this.repeats) {
        case 'Weekly'   : return this.selectWeekInterval; break;
        case 'Monthly'  : return this.selectMonthInterval; break;
        default: return 0; break;
      }
    }
  }
}
</script>


<style src="./CreateRoutine.scss" lang="scss" />